















import { Component, Vue, Prop } from 'vue-property-decorator';

import ShareButtons, {
  defaultSocialNetworks
} from '@/componentsV2/organisms/ShareButtons/ShareButtons.vue';
import { upperCaseFirstLetter } from '@/utils/string';
import { EASocialMedia } from '../molecules/SocialMediaButton/SocialMediaButton.vue';

export type ShareOfferGATracking = {
  eventCategory: string;
  eventAction: string;
};

@Component({
  components: {
    ShareButtons
  }
})
export default class ShareOffer extends Vue {
  @Prop({ required: true }) offer!: any;
  @Prop({ required: true }) businessName!: string;
  @Prop() gaTracking?: ShareOfferGATracking;
  @Prop({ default: () => defaultSocialNetworks() })
  networks?: EASocialMedia[];

  handleAnalytics(socialNetwork: string) {
    if (!this.gaTracking) return;

    const routePath = window.location.pathname;

    const modalLabelsByRoutePaths: Record<string, string> = {
      '/birthday-club':
        'Birthday Club creation page | Success modal | Each share options',
      '/offers': 'Offer creation page | Success modal | Each share options'
    };

    const modalShareEl = document.getElementById(
      'offer-creation-success-modal'
    );

    const isShowingModalShare =
      modalShareEl && modalShareEl.classList.contains('share-offer-addthis');

    this.$analytics({
      ...this.gaTracking,
      eventLabel: `Clicked on "${upperCaseFirstLetter(socialNetwork)}" button`,
      ...(isShowingModalShare &&
        modalLabelsByRoutePaths.hasOwnProperty(routePath) && {
          eventCategory: modalLabelsByRoutePaths[routePath]
        })
    });
  }

  get description() {
    const { title } = this.offer;

    return `${
      this.businessName
    } is offering ${title}. Get yours today on Twism.`;
  }
}
